'use client';
import { useRef } from 'react';

import useHandleOutside from '@/hooks/useHandleOutside';

import { useLocale, useTranslations } from 'next-intl';
import CloseIcon from '@/components/ui/icons/close-icon';
import { useSession } from 'next-auth/react';
import CompleteProfileBox from './complete-profile-box';
import NavLinks from './nav-links';
import sidebarMenuData from './sidebar-menu-data';
import SocialLinks from '../footer/social-links';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import {
  fetchLoyalty,
  getUserWallerBalance,
} from '@/services/checkout/checkout-server';
import useSWR from 'swr';
import { socialMediaLinksData } from '@/constants/footerLinks';

const SideMenu = ({ setSide }) => {
  const ref = useRef(null);
  const locale = useLocale();
  useHandleOutside(ref, () => setSide(false));
  const t = useTranslations('common');
  const { data: session } = useSession();

  const closeMenu = () => {
    setSide(false);
  };

  const { isLoading, data: loyaltyData } = useSWR(
    session ? ['/loyalty', session?.mage, session?.user?.mobilenumber] : null,
    async () => await fetchLoyalty()
  );

  const { isLoading: isWalletLoading, data: walletData } = useSWR(
    session ? ['/wallet', session?.mage] : null,
    async () => await getUserWallerBalance()
  );

  const loyaltyPoints = loyaltyData?.data?.data?.ActivePoints || 0;
  const walletBalance = walletData?.data?.data?.store_credit || 0;

  return (
    <section className='fixed start-0 top-0 z-9999! flex w-screen'>
      <div
        ref={ref}
        className={`${locale === 'ar' ? 'ml-3' : 'mr-3'} max-h-screen min-h-screen w-full overflow-auto bg-[#FAFBFB]`}
      >
        <button
          onClick={() => setSide(false)}
          className='flex w-full items-center justify-between p-3'
        >
          <span className='flex-1 text-center text-[14px] font-bold sm:text-[14px]'>
            {!session
              ? t('Guest - Hi Guest')
              : `${t('Hi')} ${session?.user?.firstname}`}
          </span>
          <CloseIcon className={`size-5`} />
        </button>

        <CompleteProfileBox closeMenu={closeMenu} session={session} />

        <div className='space-y-[11px] pb-[15px]'>
          <NavLinks
            links={sidebarMenuData.orderManagement}
            onClick={closeMenu}
          />
          <NavLinks links={sidebarMenuData.userAccount} onClick={closeMenu} />
          <NavLinks
            links={sidebarMenuData.loyaltyAndWallet}
            isLoading={isLoading || isWalletLoading}
            textValue={{
              Points: `${loyaltyPoints} ${t('PTS')}`,
              Wallet: (
                <>
                  {walletBalance} <CurrencyIcon className='size-3' />
                </>
              ),
            }}
            textValueColor='text-[#009900]'
            onClick={closeMenu}
          />

          <NavLinks links={sidebarMenuData.information} onClick={closeMenu} />
          {socialMediaLinksData?.value?.length ? (
            <div className='mt-6 px-6'>
              <SocialLinks socialLinksData={socialMediaLinksData} isMobile />
            </div>
          ) : null}
          <NavLinks
            links={sidebarMenuData.accountManagement}
            textColor='text-[#e11d48]'
            onClick={closeMenu}
          />
        </div>
      </div>
      <div className='flex-1 bg-black/60' />
    </section>
  );
};

export default SideMenu;
